import axios from '@/axios'


let accessToken = localStorage.accessToken;
axios.defaults.headers.post['Content-Type'] = 'application/json'
axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`

export default {
	namespaced: true,
	actions: {
		async getCategories ({commit}) {
			await axios.get('/product_category')
				.then((res) => {
					commit('SET_CATEGORIES',res.data.data)
				})
				.catch((err) => { console.log(err) })
		},
		async createProduct ({commit}, payload) {
			await axios.post('/product', payload)
				.then((res) => {
					commit('SET_SUBMITTED', res.data.data[0].product_id)
				})
				.catch((err) => { console.log(err)} )
		},
		async updateImage ({getters, commit}, images) {
			let product_id = getters.submittedProduct
			let data = new FormData()
			await images.forEach(image => {
				data.append('image', image, image.name)
			})
			return new Promise((resolve,reject) => {
				axios.post(`product/${product_id}/image`, data)
				.then((res) => {
					let sequence = []
					sequence.push(res.data.data.feature.key)
					for(let img of res.data.data.image) {
						sequence.push(img.key)
					}
					resolve(sequence)
				 })
				.catch((err) => reject(err))
			})
		},
		async updateImageSequence ({}, payload) {
			await axios.patch(`product/${payload.product_id}/sort_image`, {image: payload.image})
			.then(()=> {})
			.catch((err) => console.log(err))
		},
		async getProducts ({commit,dispatch}) {
			//await axios.get(`/product`)
			//.then(async(res) => {
				//let datas = res.data.data
				//datas.forEach(data => {
					//data.image = JSON.parse(data.image)
				//})
				//await dispatch('getPrice').then((sort_data) => {
					//for(let sd of sort_data){
						//Object.assign(datas.find(data => data.id === sd.product_id),sd)
					//}
				//})
				//commit('SET_PRODUCTS', datas)
			//})
			//.catch((err)=> {console.log(err)})
          try {
            let res = await Promise.all([
              axios.get('/product?status=0&status=1'),
              axios.get('/product/variant/list'),
            ]);

            let [product, price] = res.map((x) => x.data.data);

            let product_price = price.reduce((dic,cur) => {
              if (typeof dic[cur.product_id]==='undefined') {
                dic[cur.product_id] = {
                  min_price: parseFloat(cur.price),
                  max_price: parseFloat(cur.price),
                }
                return dic;
              }
              else if (cur.price < dic[cur.product_id]['min_price']) {
                dic[cur.product_id]['min_price'] = parseFloat(cur.price);
                return dic;
              }
              else if (cur.price > dic[cur.product_id]['max_price']) {
                dic[cur.product_id]['max_price'] = parseFloat(cur.price);
                return dic;
			  }
			  return dic;
            }, {});
			
           for (let p of product) {
              p.image = JSON.parse(p.image);
              if (typeof product_price[p.id] === 'undefined') {
                p.min_price = 0;
                p.max_price = 0;
              } else {
                p.min_price = product_price[p.id].min_price;
                p.max_price = product_price[p.id].max_price;
              }
            }

            commit('SET_PRODUCTS', product);
          } catch(e) {
            console.log(e);
            throw e;
          }
		},
		async getProduct ({commit,getters,dispatch}, payload) {
			return new Promise((resolve,reject) => {
				let id = payload.id
				axios.get(`/product/${id}`)
				.then(async(res) => {
					let variant = res.data.data
					// console.log(JSON.stringify(variant))
					//start deconstructing response data to fit frontend display
					//check how many variant in a product
					let arr = []
					for(let i= 0; i < variant.length; i++) {		
						if(variant[i].option.length > 0) {
							variant[i].option.forEach(option =>{
								if(arr.find(l => l == option.label) === undefined){
									arr.push(option.label)
								}
							})
						}
					}
					//only one variant as root variant
					let root = [], tree = [], option = []
					//no variant 
					if(!arr.length){
						Object.assign(payload, {
							variant_id: variant[0].id,
							product_price: variant[0].price, 
							product_inventory_count: variant[0].inventory_count, 
							product_sku: variant[0].sku,
							product_weight: variant[0].weight,
							product_volumetric: variant[0].volumetric,
						})
					}else if(arr.length === 1) {
							for(let i = 0; i < variant.length; i++) {
								if(root.find(l => l.value == variant[i].option[0].value) === undefined) {
									root.push({
										variant_id: variant[i].id,
										label : variant[i].option[0].label, 
										value : variant[i].option[0].value,
										price: variant[i].price, 
										inventory_count: variant[i].inventory_count, 
										sku: variant[i].sku,
										weight: variant[i].weight,
										volumetric: variant[i].volumetric,
										option: []
									})
								}
							}
						// two variant
						}else {
							for(let i = 0; i < variant.length; i++) {
								for(let j = 1; j < variant[i].option.length; j++) {
									// the root variant not found
									if(root.find(l => l.value == variant[i].option[0].value) === undefined) {
											option.push({
												variant_id: variant[i].id,
												label: variant[i].option[1].label, 
												value : variant[i].option[1].value, 
												price: variant[i].price, 
												inventory_count: variant[i].inventory_count, 
												sku: variant[i].sku,
												weight: variant[i].weight,
												volumetric: variant[i].volumetric,
											})
										
										root.push({
											label : variant[i].option[0].label, 
											value : variant[i].option[0].value,
											option: option
										})

										if(tree.find(t => t.value == option[0].value) === undefined){
											tree.push({
											label: option[0].label,
											value: option[0].value
											})
										}
										option = []
									// variant found
									}else {
										root.find(l => l.value == variant[i].option[0].value).option.push({
											variant_id: variant[i].id,
											label: variant[i].option[1].label, 
											value : variant[i].option[1].value, 
											price: variant[i].price, 
											inventory_count: variant[i].inventory_count, 
											sku: variant[i].sku,
											weight: variant[i].weight,
											volumetric: variant[i].volumetric,
										})

										if(tree.find(t => t.value == variant[i].option[1].value) === undefined){
											tree.push({
											label: variant[i].option[1].label,
											value: variant[i].option[1].value
											})
										}
									}
									break
								}
							}
						}	
					
					let product_variant = root.length > 0 ? true : false
					let isEnableRootSetting = root.length > 0 ? true : false
					let isEnableTreeSetting = isEnableRootSetting && root[0].option.length > 0 ? true : false
					await dispatch('getUser',payload.id).then((res) => { 
						let modified_product = Object.assign(payload, {
							variant: root, 
							tree: tree,
							product_variant: product_variant,
							isEnableRootSetting: isEnableRootSetting,
							isEnableTreeSetting: isEnableTreeSetting,
							added_by_fullname: res,
						})
						console.log(JSON.stringify(modified_product))
						commit('SET_PRODUCT', modified_product)
						resolve(modified_product)
					 }).catch((err) => reject(err))	
				})
			})
		},
		async removeImage({getters},remove_image) {
		let product_id = getters.submittedProduct,payload = {
			image: remove_image
		}
			await axios.post(`/product/${product_id}/remove_image`, payload)
			 .then(() => {})
			 .catch((err) => { console.log(err) })
		},
		async updateProductStatus({}, payload){
			await axios.patch(`/product/${payload.id}/status`,payload)
			.then(() => {})
			.catch((err) => { console.log(err) })
		},
		async getPrice({}) {
			return new Promise((resolve, reject) => {
				axios.get('/product/variant/list')
				.then((res) => {
					let datas = res.data.data, sort_data = []
					for(let data of datas){
						if(!sort_data.some(sd => sd.product_id === data.product_id)){
							sort_data.push({product_id:data.product_id,min_price:parseFloat(data.price),max_price:parseFloat(data.price)})
						}else {
							let found = sort_data.find(sd => sd.product_id === data.product_id)
							if(data.price > found.max_price){
								sort_data.find(sd => sd.product_id === data.product_id).max_price = parseFloat(data.price)
							}else if(data.price < found.min_price){
								sort_data.find(sd => sd.product_id === data.product_id).min_price = parseFloat(data.price)
							}
						}	
					}
					resolve(sort_data)
				})
				.catch((err)=> reject(err))
			})
		},
		async getUser({},product_id){
			return new Promise((resolve,reject) => {
				axios.get(`/product/variant/list`)
				.then((res) => {
				let added_by = res.data.data.find(data => data.product_id === product_id).added_by
				console.log(added_by)
				let full_name = added_by.first_name +' '+added_by.last_name
				resolve(full_name)
			}).catch((err)=> {reject(err)})
			})
			
		},
		async updateProductInfo({},payload){
			console.log(payload)
			await axios.patch(`/product/${payload.product_id}`,payload)
			.then(() => {})
			.catch((err) => {console.log(err)})
		},
		async updateVariant({},payload){
			await axios.post('/variant',payload)
			.then(() => {})
			.catch((err) => {console.log(err)})
		},
		async deleteProduct({},ids){
			await ids.forEach(id => {
				axios.patch(`/product/${id}/status`,{status : 2})
			})
		}
	},

	getters: {
		products: state => state.products,
		categories: state => state.categories,
		product: state => state.product,
		submittedProduct: state => state.submittedProduct,
		added_by: state => state.added_by
	},

	mutations: {
		SET_CATEGORIES(state, categories) {
			state.categories = categories
		},
		SET_PRODUCTS(state, products) {
			state.products = products
		},
		SET_PRODUCT(state, product) {
			state.product = product
		},
		SET_SUBMITTED(state, submittedProduct){
			state.submittedProduct = submittedProduct
		},
		SET_ADDED_BY(state, added_by){
			state.added_by = added_by
		}
	},
    
  state: {
    products: [],
    categories: [],
    product: {},
    submittedProduct: {},
    added_by: 0
  }
}
